import BaseIcon, { BaseIconProps } from './Base';

const IconMenu = ({ ...props }: BaseIconProps) => (
  <BaseIcon {...props} viewBox='0 0 16 16'>
    <path d='M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z' />
  </BaseIcon>
);

export default IconMenu;
